import { useState } from "react";
import { Plus } from "lucide-react";

import { Button } from "components/ui/Button";
import { Dialog } from "components/ui/Dialog";

import { AddMedicationForm } from "./AddMedicationForm";

export const AddMedicationModal = ({
  isDisabled,
  buttonClassName,
  icon = Plus,
  initialData,
  usageType = "LONGTERM",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        variant="text"
        className={buttonClassName || undefined}
        type="button"
        disabled={isDisabled}
        onClick={() => setIsModalOpen(true)}
        endIcon={icon}
      >
        {initialData ? "Edit medication" : "Add new medication"}
      </Button>
      <Dialog
        open={isModalOpen}
        title={initialData ? "Edit Medication" : "Add Medication"}
        onClose={() => setIsModalOpen(false)}
        width={1100}
      >
        <AddMedicationForm
          onSuccess={() => setIsModalOpen(false)}
          onCancel={() => setIsModalOpen(false)}
          initialData={initialData}
          usageType={usageType}
        />
      </Dialog>
    </>
  );
};
